import { render, staticRenderFns } from "./CapacitacionFormModal.vue?vue&type=template&id=af47ec04"
import script from "./CapacitacionFormModal.vue?vue&type=script&lang=js"
export * from "./CapacitacionFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports